import {
    AfterViewInit,
    Component,
    ElementRef,
    OnDestroy,
    OnInit,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { UserService } from 'app/services/user.service';
import { LayoutChromeService } from 'app/services/layout-chrome.service';
import { ViewportService } from 'app/services/viewport.service';
import { LandingLinkService } from 'app/services/landing-link.service';
import { fromEvent, Subject, takeUntil } from 'rxjs';
import {environment} from "../../../../environments/environment";

@Component({
    selector: 'empty-layout',
    templateUrl: './empty.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class EmptyLayoutComponent implements OnDestroy, OnInit, AfterViewInit {
    user: any;
    lastLogin: Date;
    mobile: boolean = false;
    // Footer bleibt fixiert (z.B. im Buchungsprozess) statt mit der Seite wegzuscrollen
    stickyFooter: boolean = false;
    // Höhe der Footer-Leiste, um beim Fixieren einen Platzhalter gleicher Größe einzufügen
    footerHeight: number;
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    readonly appVersion = environment.version;

    @ViewChild('appFooter')
    footer: ElementRef;

    /**
     * Constructor
     */
    constructor(
        private userService: UserService,
        private _navigationService: NavigationService,
        private _layoutChromeService: LayoutChromeService,
        private viewport: ViewportService,
        public landing: LandingLinkService,
    ) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    ngOnInit(): void {
        this.viewport.isMobile$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((mobile) => (this.mobile = mobile));

        this._layoutChromeService.stickyFooter$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((sticky) => {
                this.stickyFooter = sticky;
                this.updateFooterHeight();
            });

        fromEvent(window, 'resize')
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(() => this.updateFooterHeight());
    }

    ngAfterViewInit(): void {
        this.updateFooterHeight();
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    updateFooterHeight(): void {
        this.footerHeight = this.footer?.nativeElement.offsetHeight;
    }

    get currentYear(): number {
        return new Date().getFullYear();
    }
}
